import React, { Component } from 'react'
import { Dropdown as BelleDropdown } from 'belle-js'
import PropTypes from 'prop-types'
import styles from './Dropdown.module.scss'

class Dropdown extends Component {

  constructor (props) {
    super(props)
    this.state = {
      selectedOption: props.selectedItem
    }
  }

  handleClick (index) {
    const {
      onSelectItem
    } = this.props
    onSelectItem(index)
  }

  render () {
    const { selectedOption } = this.state
    const { 
      options,
      name,
      ownClass, 
      placeholder
    } = this.props

    return (
      <div className={styles.Dropdown}>
        <BelleDropdown
          name={name}
          label={options[selectedOption] || placeholder || 'Select Option'}
          dropdownClasses={ownClass} >
          <div className={styles.optionsWrapper}>
            { options.map((opt, index) => (
              <div 
                key={index} //eslint-disable-line
                onClick={this.handleClick.bind(this, index)} //eslint-disable-line
                className={styles.option} >
                {opt}
              </div>
            ))
            }
          </div>
        </BelleDropdown>
      </div>

    )
  }

}

Dropdown.propTypes = {
  options: PropTypes.array.isRequired,
  name: PropTypes.string.isRequired,
  ownClass: PropTypes.string,
  placeholder: PropTypes.string,
  onSelectItem: PropTypes.func,
  selectedItem: PropTypes.number.isRequired,
}

Dropdown.defaultProps = {
  ownClass: '',
  placeholder: '',
  onSelectItem: () => {}
}
export default Dropdown



// WEBPACK FOOTER //
// ./src/components/Shared/Dropdown/Dropdown.jsx